/*
 * Trang Tồn kho của sản phẩm. Từ 18/09/2026 Kho & LOT là nguồn tồn duy nhất: trang này chỉ đọc các lô, không
 * còn ô gõ tay số tồn. Lịch sử điều chỉnh tay có từ trước ngày đó vẫn hiện để tra.
 */
export const productStockEn = {
  productStock: {
    title: "Stock by lot",
    hint: "Stock comes from Kho & LOT. It changes only through warehouse documents: opening balance, goods receipt, delivery issue, lot transfer, stock count.",
    available: "Available", pendingShort: "Pending", pending: "Awaiting inspection / in transit", rejected: "Rejected", onHand: "Total in warehouse",
    otherUnits: "Lots in another unit ({{unit}}): {{onHand}} in warehouse, {{available}} available — not added to the figures above.",
    legacy: "Old system balance: {{quantity}} {{unit}} — for reconciliation at the opening stock count only.",
    goCounts: "Stock count / opening balance", goBalances: "Balances by lot",
    lots: "Lots", empty: "This product has no lot in any warehouse yet.", loading: "Loading lots…", error: "The lots could not be loaded.", retry: "Retry",
    warehouse: "Warehouse", location: "Location", lot: "Lot", source: "Source", supplier: "Supplier",
    kinds: { Receipt: "Purchase receipt", Opening: "Opening balance", ProductionOutput: "Production", Subcontract: "Subcontracting", SubcontractWip: "At subcontractor" },
    managedByLot: "Stock is managed by Kho & LOT: record it through warehouse documents (opening balance, goods receipt, delivery, stock count), not by typing a number.",
    history: "Manual adjustments before 18/09/2026", historyError: "The adjustment history could not be loaded.",
    number: "Document", before: "Before", after: "After", operator: "Operator", time: "Time", reasonColumn: "Reason",
  },
};
export const productStockVi = {
  productStock: {
    title: "Tồn kho theo lô",
    hint: "Số tồn lấy từ Kho & LOT. Tồn chỉ thay đổi qua chứng từ kho: tồn đầu kỳ, phiếu nhập, giao hàng xuất kho, chuyển lô, kiểm kê.",
    available: "Dùng được", pendingShort: "Chờ kiểm", pending: "Chờ kiểm / đang chuyển", rejected: "Không đạt", onHand: "Tổng trong kho",
    otherUnits: "Lô mang đơn vị khác ({{unit}}): {{onHand}} trong kho, {{available}} dùng được — không cộng vào các số trên.",
    legacy: "Số trên hệ cũ: {{quantity}} {{unit}} — chỉ để đối chiếu khi kiểm kê đầu kỳ.",
    goCounts: "Kiểm kê / tồn đầu kỳ", goBalances: "Số dư theo LOT",
    lots: "Các lô", empty: "Sản phẩm này chưa có lô nào trong kho.", loading: "Đang tải các lô…", error: "Không tải được các lô.", retry: "Thử lại",
    warehouse: "Kho", location: "Vị trí", lot: "Lô", source: "Nguồn", supplier: "Nhà cung cấp",
    kinds: { Receipt: "Nhập mua", Opening: "Tồn đầu kỳ", ProductionOutput: "Sản xuất", Subcontract: "Gia công", SubcontractWip: "Đang ở xưởng gia công" },
    managedByLot: "Tồn kho do Kho & LOT quản lý: ghi qua chứng từ kho (tồn đầu kỳ, phiếu nhập, giao hàng, kiểm kê), không gõ số trực tiếp.",
    history: "Điều chỉnh tay trước 18/09/2026", historyError: "Không tải được lịch sử điều chỉnh.",
    number: "Số phiếu", before: "Trước", after: "Sau", operator: "Người thực hiện", time: "Thời gian", reasonColumn: "Lý do",
  },
};
export const productStockZh = {
  productStock: {
    title: "按批次库存",
    hint: "库存来自“仓库与批次”，只会通过仓库单据变动：期初库存、入库、出货出库、批次调拨、盘点。",
    available: "可用", pendingShort: "待检验", pending: "待检验／运送中", rejected: "不合格", onHand: "仓内合计",
    otherUnits: "其他单位（{{unit}}）的批次：仓内 {{onHand}}，可用 {{available}}——未计入上方数字。",
    legacy: "旧系统数量：{{quantity}} {{unit}}——仅供期初盘点对账。",
    goCounts: "盘点／期初库存", goBalances: "批次结存",
    lots: "批次", empty: "此产品在仓库中尚无批次。", loading: "正在加载批次…", error: "无法加载批次。", retry: "重试",
    warehouse: "仓库", location: "库位", lot: "批次", source: "来源", supplier: "供应商",
    kinds: { Receipt: "采购入库", Opening: "期初库存", ProductionOutput: "生产", Subcontract: "委外加工", SubcontractWip: "在委外厂" },
    managedByLot: "库存由“仓库与批次”管理：请通过仓库单据（期初库存、入库、出货、盘点）记录，不可直接输入数字。",
    history: "2026/09/18 前的手动调整", historyError: "无法加载调整记录。",
    number: "单号", before: "调整前", after: "调整后", operator: "操作人", time: "时间", reasonColumn: "原因",
  },
};
